import { render, staticRenderFns } from "./ParticipationStatusIndicator.vue?vue&type=template&id=5a78e07e&"
import script from "./ParticipationStatusIndicator.vue?vue&type=script&lang=js&"
export * from "./ParticipationStatusIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports